/**
 * Bottone "Compila da P.IVA": interroga il registro ufficiale UE (VIES) e
 * compila automaticamente ragione sociale, indirizzo, CAP, città e provincia.
 */
import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { API } from "../utils/format";

export const VatLookupButton = ({ vat, onFill, currentSdi }) => {
  const [loading, setLoading] = useState(false);
  const lookup = async () => {
    const clean = (vat || "").trim();
    if (clean.replace(/\D/g, "").length < 8) {
      toast.error("Inserisci prima una Partita IVA valida");
      return;
    }
    setLoading(true);
    try {
      const r = await axios.get(`${API}/vat-lookup/${encodeURIComponent(clean)}`);
      if (!r.data.found) {
        toast.error("P.IVA non trovata nel registro imprese UE (VIES)");
        return;
      }
      const d = r.data;
      const patch = {};
      ["business_name", "address", "cap", "city", "province"].forEach((k) => { if (d[k]) patch[k] = d[k]; });
      if (d.sdi_code && !currentSdi) patch.sdi_code = d.sdi_code;
      onFill(patch);
      toast.success(`Dati compilati: ${d.business_name}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore nella ricerca P.IVA");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Button
      type="button"
      variant="outline"
      onClick={lookup}
      disabled={loading}
      className="border-[#8A1C2A] text-[#8A1C2A] hover:bg-[#8A1C2A]/10 shrink-0 px-2.5"
      title="Compila automaticamente ragione sociale e indirizzo dalla P.IVA (registro imprese UE)"
      data-testid="vat-lookup-btn"
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
      <span className="ml-1 text-xs">Compila</span>
    </Button>
  );
};

export default VatLookupButton;
